import React from "react";
import Header from "./Header";
import SideDrawer from "./SideDrawer";
import "./NavigationLayout.scss";

const NavigationLayout = ({ children }: { children: any }) => {
  return (
    <div className="navigation_layout_container">
      <Header />
      <SideDrawer />
      <div className="layout_container">{children}</div>
    </div>
  );
};

export default NavigationLayout;
